import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconUser = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.333 8.66667C10.333 7.74619 11.0792 7 11.9997 7C12.9201 7 13.6663 7.74619 13.6663 8.66667C13.6663 9.58714 12.9201 10.3333 11.9997 10.3333C11.0792 10.3333 10.333 9.58714 10.333 8.66667ZM11.9997 5C9.97463 5 8.33301 6.64162 8.33301 8.66667C8.33301 10.6917 9.97463 12.3333 11.9997 12.3333C14.0247 12.3333 15.6663 10.6917 15.6663 8.66667C15.6663 6.64162 14.0247 5 11.9997 5ZM9.33317 13C7.30813 13 5.6665 14.6416 5.6665 16.6667V18H7.6665V16.6667C7.6665 15.7462 8.4127 15 9.33317 15H14.6665C15.587 15 16.3332 15.7462 16.3332 16.6667V18H18.3332V16.6667C18.3332 14.6416 16.6915 13 14.6665 13H9.33317Z"
        />
      </svg>
    );
  }
);
